module.exports = __webpack_public_path__ + "img/service_progress_3.7aee9995.png";